import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'

const messages = {
    fr : {
        message: {
            geolocalisation: 'Je suis sur place',
            geolocalisationdisable: 'Désactiver la géolocalisation',
            ajouter_carnet: 'Ajouter au carnet',
            retirer_carnet: 'Retirer du carnet',
            aucune_offre: 'Aucune offre',
            plus_offres: "Afficher plus d'offres",
            affiner_recherche : "Affiner ma recherche",
            fermer_filtres : "Fermer les filtres",
            resultats : "résultats",
            resultat : "résultat",
            selection : "Ma sélection",
            masquer_carte : "Masquer la carte",
            afficher_carte : "Afficher la carte",
            a_partir_de : "à partir de",
            gratuit : "Gratuit",
            recherche_dates : "Rechercher par dates",
            textsur: "sur"
        },
        date: {
            du: 'Du',
            au: 'au'
        },
        map: {
            consulter: 'Consulter l\'offre'
        }
    },
    en: {
        message: {
            geolocalisation: "I'm here",
            geolocalisationdisable: 'Deactivate geolocation',
            ajouter_carnet: 'Add to notebook',
            retirer_carnet: 'Remove from notebook',
            aucune_offre: 'No offers',
            plus_offres: "View more offers",
            affiner_recherche : "Refine my search",
            fermer_filtres : "Close filters",
            resultats : "results",
            resultat : "result",
            selection : "My selection",
            masquer_carte : "Hide map",
            afficher_carte : "Show map",
            a_partir_de : "from",
            gratuit : "Free",
            recherche_dates : "Search by date",
            textsur: "on"
        },
        date: {
            du: 'From',
            au: 'to'
        },
        map: {
            consulter: 'Consult the offer'
        }
    },
    es: {
        message: {
            geolocalisation: 'Ya estoy aquí',
            geolocalisationdisable: 'Desactivar la geolocalización',
            ajouter_carnet: 'Añadir a la libreta',
            retirer_carnet: 'Retirar del cuaderno',
            aucune_offre: 'No hay ofertas',
            plus_offres: "Ver más ofertas",
            affiner_recherche : "Afinar mi búsqueda",
            fermer_filtres : "Cerrar filtros",
            resultats : "resultados",
            resultat : "resultado",
            selection : "Mi selección",
            masquer_carte : "Ocultar mapa",
            afficher_carte : "Mostrar mapa",
            a_partir_de : "de",
            gratuit : 'Gratis',
            recherche_dates : "Buscar por fecha",
            textsur: "en"
        },
        date: {
            du: 'En',
            au: 'en'
        },
        map: {
            consulter: 'Consultar la oferta'
        }
    }
};
import App from './App.vue'

const i18n = createI18n({ // eslint-disable-next-line
    locale: comtourismeplugin.lang, // set locale
    fallbackLocale: 'fr', // set fallback locale
    messages, 
});

createApp(App).use(i18n).mount('#moteur')
